
import { StdResponse, bimAxios } from "@/config/axios"

export function findGutterSectionsByprojectUuid(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/gutter-sections`, {
        params: {
            ...params,
        }
    })
}

export function addGutterSection(projectUuid: string, data: any, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/gutter-sections`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteGutterSectionByUuid(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/gutter-sections/${uuid}`, {
        params: {
            ...params,
        }
    })
}

export function updateGutterSection(uuid: string, data: any, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/gutter-sections/${uuid}`, data, {
        params: {
            ...params,
        }
    })
}

export function findGutterSectionByUuid(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/gutter-sections/${uuid}`, {
        params: {
            ...params,
        }
    })
}
